module.exports = __webpack_public_path__ + "assets/reply_icon.3051fb55.svg";